import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./App.css";
import { Home } from "./Home";
import { Projects } from "./Projects";
import { Contacts } from "./Contacts";
import { allStories } from "./Stories";
import { getStorySlug } from "./methods";
import { Evolving } from "./Evolving";
import { Story } from "./stories/StoryPage";
import { LangType } from "./hooks/useTranslation";
import { NavBar } from "./NavBar";
import { Exhibition } from "./Exhibition";
import { ColorWheel } from "./ColorWheel";
import { PortraitsBlackAndWhite } from "./PortraitsBlackAndWhite";
import { PortraitsColor } from "./PortraitsColor";
import AboutMe from "./AboutMe";

const MAIN_PATH = "/";
export const STORIES_PATH = "/stories";
const PROJECTS_PATH = "/projects";
const CONTACTS_PATH = "/contacts";
const EXHIBITION_PATH = "/exhibition";
const EXPERIMENTS_PATH = "/experiments";
const COLOR_WHEEL_PATH = "/exhibition/color-wheel";
const PORTRAITS_BW_PATH = "/exhibition/portraits-black-and-white";
const PORTRAITS_COLOR_PATH = "/exhibition/portraits-color";

function App() {
  const getDefaultLang = (): LangType => {
    const browserLang = navigator.language || navigator.languages?.[0] || "en";
    if (browserLang.toLowerCase().startsWith("uk")) return LangType.UA;
    return LangType.EN;
  };

  const [lang, setLang] = useState<LangType>(getDefaultLang());

  const routes = [
    { path: MAIN_PATH, element: <Home lang={lang} /> },
    { path: PROJECTS_PATH.slice(1), element: <Projects lang={lang} /> },
    { path: CONTACTS_PATH.slice(1), element: <Contacts lang={lang} /> },
    { path: EXHIBITION_PATH.slice(1), element: <Exhibition lang={lang} /> },
    { path: COLOR_WHEEL_PATH.slice(1), element: <ColorWheel /> },
    { path: PORTRAITS_BW_PATH.slice(1), element: <PortraitsBlackAndWhite /> },
    { path: PORTRAITS_COLOR_PATH.slice(1), element: <PortraitsColor /> },
    { path: EXPERIMENTS_PATH.slice(1), element: <Evolving lang={lang} /> },
    { path: "about-me", element: <AboutMe /> },
    // Story routes
    ...allStories.map((story, i) => ({
      path: getStorySlug(story["EN"].header),
      element: <Story story={story[lang]} />,
      key: i,
    })),
  ];

  const socialLinks = [
    {
      href: "https://www.instagram.com/vorona_yulia",
      label: "Instagram",
      icon: "bi-instagram",
    },
    {
      href: "https://www.facebook.com/juju.vorona",
      label: "Facebook",
      icon: "bi-facebook",
    },
    {
      href: "https://www.linkedin.com/in/yuliia-sugak-54b29a66/",
      label: "LinkedIn",
      icon: "bi-linkedin",
    },
  ];

  return (
    <div className="App">
      <NavBar lang={lang} setLang={setLang} />
      <Routes>
        {routes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
      </Routes>
      <footer className="footer">
        {socialLinks.map(({ href, label, icon }) => (
          <a key={label} href={href} aria-label={label}>
            <i className={`bi ${icon}`}></i>
          </a>
        ))}
      </footer>
    </div>
  );
}

export default App;
